import React, {Component} from 'react';
import {Link} from "react-router-dom";

import logoImage from './img/transparent_background_logo.png';
import "./decoration.css";
import {fetchUserToken, fetchShoppingCartItems} from "../../redux/actions";
import _ from 'lodash';
import {connect} from 'react-redux';
const style = {

  backgroundColor:"#000",
  opacity:0.8
}
class HeaderMainpage extends Component {
  constructor(props){
    super(props);
    this.state={
      loading:true
    }
  }
  componentWillMount(){
      console.log("componentWillMount", this.props.shoppingCartItems);
      this.props.fetchUserToken().then(() => {
        this.props.fetchShoppingCartItems(this.props.userToken).then(() => {
            console.log("componentWillMount", this.props.shoppingCartItems);
        });
      })
    } 
    render() {
      let cartBadge = undefined;
      if(this.props.shoppingCartItems !== 'Shopping cart is empty!'){
        console.log("render", this.props.shoppingCartItems);
        cartBadge =  <div className="cart-badge">{this.props.shoppingCartItems.length }</div>
      }
      else{
        cartBadge = undefined
      }
      return (
        <div className="header head_mainpage" style={style}>
            <span className="col-md-4 col-xs-4" id="left_header_icon">
            <a  href="https://www.facebook.com/BorisnMatthew/" target="_blank"><i className="fab fa-facebook-f header_icon" ></i></a>
            <a href="https://www.instagram.com/borisnmatthew/" target="_blank"><i className="fab fa-instagram header_icon" ></i></a>
            </span>
            <span className="col-md-4 col-xs-4" id="brand_icon">
              <Link to="/"><img src={logoImage} alt="LOGO" /> </Link>
            </span>
            <span className="col-md-4 col-xs-4" id="right_header_icon">
              { cartBadge  }
              <Link to="/order/cartlist"><i className="fa fa-shopping-cart header_icon"></i></Link>
              <Link to="/contact-us"><i className="fa fa-comments header_icon"></i></Link>
            </span>
        </div>
      );
    }
}
function mapStateToProps(state){
  return({
    shoppingCartItems: state.shoppingCartItems,
    userToken: state.userToken
  });
}

export default connect(mapStateToProps, {fetchUserToken, fetchShoppingCartItems})(HeaderMainpage);



// WEBPACK FOOTER //
// ./src/components/decoration/headerMainpage.js